module.exports = __webpack_public_path__ + "img/bus-2.c45621c2.png";